export var isUserActiveInP24 = function (merchantResponseData) {
    return merchantResponseData.data.merchantData.activity;
};
